const translations = {
  "en": {
    "Today": "Today"
  },
  "zh-tw": {
    "Today": "今天"
  }
};

export default translations;
